import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.slice";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TicketService from '@/service/ticket';
import Bus from '@/util/eventBus';
export default {
  data: function data() {
    return {
      list: [],
      showMarquee: [false, false],
      currentMarquee: [],
      timer: [],
      nextIndex: 0
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              Bus.$on('buyTicketSuccess', _this.refresh);
              _context.next = 3;
              return _this.getTicketMarquee();

            case 3:
              _this.animate();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.timer.forEach(function (timer) {
      if (timer) {
        clearTimeout(timer);
      }
    });
  },
  methods: {
    refresh: function refresh() {
      this.getTicketMarquee();
    },
    getTicketMarquee: function getTicketMarquee() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _res$datas, res;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return TicketService.getTicketMarquee();

              case 3:
                res = _context2.sent;

                if ((_res$datas = res.datas) === null || _res$datas === void 0 ? void 0 : _res$datas.length) {
                  _this2.list = res.datas;
                }

                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                console.error(_context2.t0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }))();
    },
    animateSingle: function animateSingle(index) {
      var _this3 = this;

      this.$set(this.showMarquee, index, false);
      this.$set(this.currentMarquee, index, this.list[this.nextIndex]);
      this.nextIndex = (this.nextIndex + 1) % this.list.length; // 控制下一个出现的时机 500-5500ms之间随机

      this.timer[this.currentMarquee.length] = setTimeout(function () {
        _this3.$set(_this3.showMarquee, index, true); // 3s后消失


        _this3.timer[index] = setTimeout(function () {
          _this3.animateSingle(index);
        }, 3000);
      }, 500 + Math.ceil(Math.random() * 5) * 1000);
    },
    animate: function animate() {
      var _this4 = this;

      if (this.list.length) {
        this.currentMarquee = this.list.slice(0, 2);
        this.nextIndex = 3 % this.list.length; // 初始化

        this.currentMarquee.forEach(function (item, i) {
          if (i > 0) {
            // 跑马灯之间时间差
            setTimeout(function () {
              _this4.timer[i] = setTimeout(function () {
                _this4.animateSingle(i);
              }, 3000);
            }, 2000 * i);
          } else {
            _this4.timer[i] = setTimeout(function () {
              _this4.animateSingle(i);
            }, 3000);
          }
        });
      }
    }
  }
};